import {
  getInitialDate,
  getFinalDate,
} from '@/services/dateTime/datetimeService';

const minimumDate = getInitialDate();
const maximumDate = getFinalDate();

const conditionFields = () => ({
  oilInitialTemperature: {
    label: 'fields.engineering.load-simulation.oil-initial-temperature',
    required: true,
    maxLength: 7,
    precision: 3,
    minValue: -55,
    maxValue: 200,
    hidden: false,
  },
  windingInitialTemperature: {
    label: 'fields.engineering.load-simulation.winding-initial-temperature',
    required: true,
    maxLength: 7,
    precision: 3,
    minValue: -55,
    maxValue: 200,
    hidden: false,
  },
  windingTimeConstant: {
    label: 'fields.engineering.load-simulation.winding-time-constant',
    maxLength: 5,
    required: true,
    minValue: 60,
    maxValue: 1200,
    hidden: false,
  },
  windingHotspotFactor: {
    label: 'fields.engineering.load-simulation.winding-time-constant',
    required: true,
    maxLength: 4,
    precision: 1,
    minValue: 1,
    maxValue: 2,
    hidden: false,
  },
  simulationInitialDate: {
    label: 'fields.engineering.load-simulation.simulation-initial-date',
    required: true,
    minValue: minimumDate,
    maxValue: maximumDate,
    hidden: false,
  },
  simulationInitialTime: {
    label: 'fields.engineering.load-simulation.simulation-initial-time',
    required: true,
    hidden: false,
  },
  considerHumidity: {
    label: 'fields.engineering.load-simulation.consider-humidity',
    required: true,
    hidden: false,
  },
  paperHumiditySource: {
    label: 'fields.engineering.load-simulation.paper-humidity-source',
    required: false,
    hidden: false,
  },
  paperHumidity: {
    label: 'fields.engineering.load-simulation.paper-humidity',
    required: false,
    maxLength: 5,
    precision: 1,
    minValue: 0.1,
    maxValue: 99.9,
    hidden: true,
  },
  referenceHumidityBase: {
    label: 'fields.engineering.load-simulation.reference-humidity-base',
    required: false,
    hidden: false,
  },
  referenceHumidity: {
    label: 'fields.engineering.load-simulation.reference-humidity',
    required: false,
    maxLength: 5,
    precision: 1,
    minValue: 0.1,
    maxValue: 99.9,
    hidden: true,
  },
  methodForHumidityCurve: {
    label: 'fields.engineering.load-simulation.method-for-humidity-curve',
    required: false,
    hidden: false,
  },
  oilOxygen: {
    label: 'fields.engineering.load-simulation.oil-oxygen',
    required: false,
    maxLength: 10,
    precision: 1,
    minValue: 0.1,
    maxValue: 1000000,
    hidden: true,
  },
  coolingCommand: {
    label: 'fields.engineering.load-simulation.cooling-command',
    required: true,
    hidden: false,
  },
  stage1: {
    label: 'fields.engineering.load-simulation.stage-1',
    maxLength: 7,
    precision: 3,
    minValue: -55,
    maxValue: 200,
    hidden: false,
  },
  stage2: {
    label: 'fields.engineering.load-simulation.stage-2',
    maxLength: 7,
    precision: 3,
    minValue: -55,
    maxValue: 200,
    hidden: false,
  },
  stage3: {
    label: 'fields.engineering.load-simulation.stage-3',
    maxLength: 7,
    precision: 3,
    minValue: -55,
    maxValue: 200,
    hidden: false,
  },
  stage4: {
    label: 'fields.engineering.load-simulation.stage-4',
    maxLength: 7,
    precision: 3,
    minValue: -55,
    maxValue: 200,
    hidden: false,
  },
  hysteresisCoolingShutdown: {
    label: 'fields.engineering.load-simulation.hysteresis-cooling-shutdown',
    required: true,
    maxLength: 6,
    precision: 3,
    minValue: 0,
    maxValue: 20,
    hidden: false,
  },
  oilAlarmTemperature: {
    label: 'fields.engineering.load-simulation.oil-alarm-temperature',
    required: true,
    precision: 3,
    maxLength: 7,
    minValue: 20,
    maxValue: 200,
    hidden: false,
  },
  oilShutdownTemperature: {
    label: 'fields.engineering.load-simulation.oil-shutdown-temperature',
    required: true,
    precision: 3,
    maxLength: 7,
    minValue: 20,
    maxValue: 200,
    hidden: false,
  },
  windingAlarmTemperature: {
    label: 'fields.engineering.load-simulation.winding-alarm-temperature',
    required: true,
    precision: 3,
    maxLength: 7,
    minValue: 20,
    maxValue: 200,
    hidden: false,
  },
  windingShutdownTemperature: {
    label: 'fields.engineering.load-simulation.winding-shutdown-temperature',
    required: true,
    precision: 3,
    maxLength: 7,
    minValue: 20,
    maxValue: 200,
    hidden: false,
  },
  normEndLifeCriteria: {
    label: 'fields.engineering.load-simulation.norm-end-life-criteria',
    required: true,
    hidden: false,
  },
  normTemperatureCalculation: {
    label: 'fields.engineering.load-simulation.norm-temperature-calculation',
    required: true,
    hidden: false,
  },
});

export default conditionFields;
